export default "__VITE_PUBLIC_ASSET__6a188240__"